import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer, Table } from 'components';
import Body from './Body';
import API from 'services/api';
import moment from 'moment';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const Index = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [activeHsppExistingVsNewPatientDetails, setActiveHsppExistingVsNewPatientDetails] =
    useState(state.activeHsppExistingVsNewPatientDetails);
  const [searchInput, setSearchInput] = useState('');

  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [inSync, setInSync] = useState(false);

  const activeHsppPatientOptions = [
    { label: 'Location Name', value: 'location_name' },
    { label: 'Franchise Name', value: 'franchise_name' },
    { label: 'Location Group', value: 'location_group' },
    { label: 'State', value: 'state' },
    { label: 'Total', value: 'total' }
  ];

  useEffect(() => {
    init();
    // getActiveHsppStateLocationReport();
  }, [activeHsppExistingVsNewPatientDetails.search_by]);
  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  const syncReport = () => {
    setInSync(true);
    toast
      .promise(
        async () => {
          await API.SyncAmplifonPatientReport();
          init();
        },
        {
          pending: 'Report sync is in progress',
          success: 'Data is up to date now',
          error: 'Failed to sync report'
        }
      )
      .then(() => setInSync(false));
  };

  const init = () => {
    dispatch(loadingStart());
    API.getActiveHsppExistingVsNewPatientReport(activeHsppExistingVsNewPatientDetails)
      .then((response) => {
        if (response) {
          setTableData(response);
          setOriginalData(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  // const onRowExpanded = async (row) => {
  //   dispatch(loadingStart());
  //   await API.getActiveHsppStateLocationReport({
  //     start_date: activeHsppExistingVsNewPatientDetails.start_date,
  //     current_date: activeHsppExistingVsNewPatientDetails.current_date,
  //     location_name: row.locations
  //   })
  //     .then((response) => {
  //       if (response) {
  //         setTableData((prev) => {
  //           const items = [...prev];
  //           const index = items.findIndex((x) => row.state === x.state);
  //           items[index]['expanded_data'] = response;
  //           items[index]['child_component'] = ChildComponent;
  //           return items;
  //         });
  //       }
  //     })
  //     .finally(() => {
  //       dispatch(loadingStop());
  //     });
  // };

  const onRowExpanded = async (row) => {
    try {
      dispatch(loadingStart());

      const response = await API.getActiveHsppNewPatientDetails({
        new_patient_ids: row.new_patient_ids
      });

      if (response) {
        const searchBy = activeHsppExistingVsNewPatientDetails?.search_by.value || 'total';

        setTableData((prev) =>
          prev.map((item) => {
            // dynamic matching based on search_by
            if (item?.[searchBy] === row?.[searchBy]) {
              return {
                ...item,
                expanded_data: response,
                child_component: ChildComponent
              };
            }

            return item;
          })
        );
      }
    } finally {
      dispatch(loadingStop());
    }
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          setTableData,
          tableData,
          activeHsppExistingVsNewPatientDetails,
          activeHsppPatientOptions,
          setActiveHsppExistingVsNewPatientDetails,
          init,
          searchInput,
          setSearchInput,
          inSync,
          syncReport,
          onRowExpanded
        }}
      />
    </DashboardContainer>
  );
};

export default Index;

const HelloWorld = () => {
  return <div>Hello World</div>;
};

const ChildComponent = ({ tableData = [] }) => {
  const columns = [
    {
      accessor: 'hspp_id',
      Header: 'HSPP ID',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => (
        <Link to={`/customer-info/${row.original._id}`} className="text-blue-500 font-medium">
          {row.original.hspp_id}
        </Link>
      )
      // width: 200
    },
    {
      accessor: 'customer_id',
      Header: 'Customer ID',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => <div>{row.original.customer_id}</div>
      // width: 200
    },
    {
      accessor: 'customer_name',
      Header: 'Customer Name',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => <div>{row.original.customer_name}</div>
      // width: 200
    },
    {
      accessor: 'location_name',
      Header: 'Location Name',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => <div>{row.original.location_name}</div>
      // width: 200
    },
    {
      accessor: 'franchise_name',
      Header: 'Franchise Name',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => <div>{row.original.franchise_name}</div>
      // width: 200
    }
  ];
  return (
    <>
      {tableData.length > 0 ? (
        <div className="flex flex-col gap-4">
          <h3 className="text-body-color">New Active HSPP Patient Details</h3>
          <Table
            keyField="_id"
            columns={columns}
            data={tableData}
            headerComponent={null}
            maxRows={20}
            minRows={1}
          />
        </div>
      ) : (
        <div className="p-4">No patient details found</div>
      )}
    </>
  );
};
